import React, {ReactNode} from 'react';

import {Tag} from 'folder-items/FileConstants';
import TagValueViewer from 'metadata/TagValueViewer';
import {Cell} from 'notebook/tables/constants/CellConstants';
import {FIELD_TYPES, SchemaField} from 'schemas/fields/SchemaFieldConstants';

import {AssayResult, AssayRun} from './AssayRecordConstants';
import {getTagForField} from './getTagForField';

export function AssayRecordField({
  tag,
  summarize,
  shouldPreviewImages,
}: {
  tag?: Tag | null;
  summarize?: boolean;
  shouldPreviewImages?: boolean;
}): JSX.Element {
  return tag != null ? (
    <TagValueViewer tag={tag} summarize={summarize} shouldPreviewImages={shouldPreviewImages} />
  ) : (
    <>''</>
  );
}

export function CellWrapper({children}: {children: ReactNode}): JSX.Element {
  return <div className="resultsAttachment-cell">{children}</div>;
}

export function renderFieldForSpreadsheet(assayRecord: AssayResult | AssayRun, field: SchemaField): Cell {
  const tag = getTagForField(assayRecord, field.id);
  if (tag == null || tag.value == null) {
    return {text: ''};
  } else {
    const alignRight = [
      FIELD_TYPES.FLOAT.type,
      FIELD_TYPES.INTEGER.type,
      FIELD_TYPES.DATE.type,
      FIELD_TYPES.DATETIME.type,
    ].includes(tag.tagSchemaField.fieldType);
    return {
      align: alignRight ? 'right' : 'left',
      formattedValue: (
        <CellWrapper>
          <TagValueViewer tag={tag} shouldPreviewImages={true} shouldCollapseBlobs={false} />
        </CellWrapper>
      ),
      text: tag.value,
    };
  }
}
